// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2uvb4","info":"UpdateTermsInfo_info__3MVng"};